module.exports = __webpack_public_path__ + "static/media/newSequence.bfeacdb7.mp3";